import './styles.css';

/** Shared entry for marketing legal pages — match app WA dark theme. */
document.documentElement.classList.add('wa-theme-active', 'wa-dark', 'js');
